"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { Flex, FlexCenter, FlexColumn, useToasts } from "@opensea/ui-kit";
import { Add, Delete } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { MediaUpload } from "@/components/studio/MediaUpload";
import { useOverviewPreviewStore } from "../../../OverviewPreviewProvider/OverviewPreviewProvider";
import { PreviewImageMediaUpload } from "./PreviewImageMediaUpload";
import { PreviewImageThumbnail } from "./PreviewImageThumbnail";
export function PreviewImagesPreview() {
  const $ = _c(26);
  const [slug, previewImages, addPreviewImage, deletePreviewImage] = useOverviewPreviewStore(useShallow(_temp));
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const {
    showErrorMessage
  } = useToasts();
  const t = useTranslations("PreviewImagesPreview");
  let t0;
  if ($[0] !== addPreviewImage || $[1] !== previewImages.length) {
    t0 = previewImageData => {
      addPreviewImage(previewImageData);
      setSelectedImageIndex(previewImages.length);
    };
    $[0] = addPreviewImage;
    $[1] = previewImages.length;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== selectedImageIndex || $[4] !== t0) {
    t1 = <PreviewImageMediaUpload onSuccess={t0} selectedImageIndex={selectedImageIndex} />;
    $[3] = selectedImageIndex;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== deletePreviewImage || $[7] !== previewImages || $[8] !== selectedImageIndex) {
    let t3;
    if ($[10] !== deletePreviewImage || $[11] !== previewImages.length || $[12] !== selectedImageIndex) {
      t3 = (previewImage, index) => <div className="relative basis-1/4" key={index}><PreviewImageThumbnail image={previewImage} isSelected={selectedImageIndex === index} onClick={() => setSelectedImageIndex(index)} /><Button className="absolute top-1 right-1 h-6 w-6 min-w-0 p-1" icon={<Delete size={14} />} onClick={e => {
          e.stopPropagation();
          deletePreviewImage(index);
          if (selectedImageIndex >= previewImages.length - 1) {
            setSelectedImageIndex(Math.max(0, previewImages.length - 2));
          }
        }} size="sm" variant="secondary" /></div>;
      $[10] = deletePreviewImage;
      $[11] = previewImages.length;
      $[12] = selectedImageIndex;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    t2 = previewImages.map(t3);
    $[6] = deletePreviewImage;
    $[7] = previewImages;
    $[8] = selectedImageIndex;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[14] !== addPreviewImage || $[15] !== previewImages.length || $[16] !== showErrorMessage || $[17] !== slug || $[18] !== t) {
    t3 = previewImages.length && previewImages.length < 4 ? <FlexCenter asChild={true} className="col-span-1 aspect-square justify-center rounded-lg border border-border-1 border-dashed bg-bg-primary-transparent"><MediaUpload onError={() => {
        showErrorMessage(t("uploadFailed"));
      }} onSuccess={t4 => {
        const {
          file,
          token,
          url
        } = t4;
        const previewImageData_0 = {
          token,
          url,
          mediaType: file.type.startsWith("video/") ? "VIDEO" : "IMAGE"
        };
        addPreviewImage(previewImageData_0);
      }} section="ABOUT" slug={slug} supportedFileTypes={["jpg", "png", "gif", "webp", "mp4"]} uploadAttribute="PREVIEW_MEDIA"><Add size={32} /></MediaUpload></FlexCenter> : null;
    $[14] = addPreviewImage;
    $[15] = previewImages.length;
    $[16] = showErrorMessage;
    $[17] = slug;
    $[18] = t;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t2 || $[21] !== t3) {
    t4 = <Flex className="grid grid-cols-4 gap-4">{t2}{t3}</Flex>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t1 || $[24] !== t4) {
    t5 = <FlexColumn className="gap-4">{t1}{t4}</FlexColumn>;
    $[23] = t1;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}
function _temp(state) {
  return [state.slug, state.previewImages, state.addPreviewImage, state.deletePreviewImage];
}